import React from 'react';
import PropTypes from 'prop-types';

import { useLesson } from 'modules/attendance/hooks';
import { useStudents, useGroupStudents } from 'modules/students/hooks';

import LessonForm, { useLessonForm } from 'modules/attendance/components/LessonForm';

const AddAttendance = (props) => {
  const { courseId, groupId, lessonId, onCompletion } = props;

  const { lesson, onCreateLesson, creatingLesson, onUpdateLesson, updatingLesson } = useLesson({
    courseId,
    groupId,
    lessonId,
    onLessonCreated: onCompletion,
    onLessonUpdated: onCompletion,
  });

  const { students, loading: loadingStudents } = useStudents({ courseId });
  const { groupStudents } = useGroupStudents({
    students,
    groupId,
  });

  const lessonFormProps = useLessonForm({
    lesson,
    students: groupStudents,
    loadingStudents,
    submitting: creatingLesson || updatingLesson,
    onSubmit: lessonId ? onUpdateLesson : onCreateLesson,
  });

  return <LessonForm {...lessonFormProps} />;
};

AddAttendance.propTypes = {
  courseId: PropTypes.string,
  groupId: PropTypes.string,
  lessonId: PropTypes.string,

  onCompletion: PropTypes.func,
};

AddAttendance.defaultProps = {
  courseId: undefined,
  groupId: undefined,
  lessonId: undefined,

  onCompletion: undefined,
};

export default AddAttendance;
